export default "::ng-deep .endorsement-modal-body #radio-list-control {\n  display: flex;\n  flex-direction: column;\n}";